let intl = null; // Ensure it starts as null

// Function to set the intl instance globally
export const setIntl = (intlInstance) => {
  intl = intlInstance;
};

// Function to translate messages
export const translate = (id, defaultMessage = id, values = {}) => {
  if (!intl) {
    console.warn("Intl instance is not set. Returning default message.");
    return defaultMessage;
  }
  return intl.formatMessage({ id, defaultMessage }, values);
};
